import React from 'react';

import {
    Button,
    Flash,
    Form,
    FormSection,
    FormField,
    Input,
    Checkbox,
    ColumnLayout,
    Table,
    TableSelection,
    TablePagination,
    Modal,
    Spinner,
    Multiselect,
    Textarea

} from 'AWS-UI-Components-React';

import {
    JSClient,
    Header
} from './common';

export const COLUMN_DEFINITIONS = [
    {
        id: 'packageChangeId',
        header: () => 'Change Id',
        cell: (item) => item.id,
        minWidth: '100px',
        allowLineWrap: false
    },
    {
        id: 'createdAt',
        header: () => 'Created At',
        cell: (item) => new Date(item.createdAt).toString(),
        minWidth: '100px',
        allowLineWrap: false
    },
    {
        id: 'description',
        header: () => 'Description',
        cell: (item) => item.description,
        minWidth: '100px',
        allowLineWrap: false
    },
];

export class ChangeTable extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            application: this.props.applicationName,
            unknownloaderror: false,
            initialLoadDone: false,
            user: "",
            changeCommitsLoadDone: false,
            changeCommits: [],
            creatingReleaseNote: false,
            isEditting: false,
            isSaving: false,

            marketplaceOptions:[
                {
                    "label": "ALL",
                    "id": "ALL",
                    "description": "world wide"
                },
                {
                    "label": "realm",
                    "options": this.getRealmOptions(),
                    "id": "realm",
                },
                {
                    "label": "marketplace",
                    "options": this.getMarkplaceOptions(),
                    "id": "marketplace",
                }
            ],
            needManualVerify: false
        };

        this.clientLoaded = this.clientLoaded.bind(this);
        this.showAddModal = this.showAddModal.bind(this);
        this.hideAddModal = this.hideAddModal.bind(this);

        this.saveReleaseNote = this.saveReleaseNote.bind(this);
        this.markNotUsed = this.markNotUsed.bind(this);
        this.getBeersResultHandler = this.getBeersResultHandler.bind(this);
        this.loadChangeCommits = this.loadChangeCommits.bind(this);

        this.handleSelectionChange = this.handleSelectionChange.bind(this);
        this.handleImpactedMarketplacesChange = this.handleImpactedMarketplacesChange.bind(this);
        this.handleNeedManualVerifyChange = this.handleNeedManualVerifyChange.bind(this);
        this.handleCodeReviewsChange = this.handleCodeReviewsChange.bind(this);
    }

    getMarkplaceOptions() {
        return [
            "US", "CA", "MX", "BR",
            "UK", "IT", "ES", "FR", "DE", "IN",
            "JP", "AU",
            "CN"
        ].map((m) => {
            return {
                "label": m,
                "id": m,
                "description": "marketplace"
            }
        });
    }

    getRealmOptions() {
        return ["NA", "EU", "FE", "CN"].map((r) => {
            return {
                "label": r,
                "id": `${r}Realm`,
                "description": "realm"
            }});
    }

    handleSelectionChange(d) {
        let selectedChanges = d.detail.selectedItems;
        let allDescriptions = selectedChanges.map((it) => it.description);
        let releaseNoteDecription = allDescriptions.map((it) => it.split("\n")[0]).join("\n");
        let releaseNoteCRs = selectedChanges.map((it) => {
            let lines = it.description.split("\n");
            if (lines.length > 2) {
                const matched = lines[2].match(/CR-[\d]+/);
                return matched && matched[0];
            }
        }).filter((it) => it);
        this.setState({ selectedChanges, releaseNoteDecription, releaseNoteCRs });
    }

    handleImpactedMarketplacesChange(d) {
        this.setState({impactedMarketplaces: d.detail.selectedIds})
    }

    handleNeedManualVerifyChange(d) {
        this.setState({needManualVerify: d.detail.checked});
    }

    handleCodeReviewsChange(d) {
        let value = (d.detail.value || "");
        let codeReviews = value.split("\n").map((it) => it.trim()).filter((it) => it);
        this.setState({releaseNoteCRs: codeReviews});
    }

    clientLoaded(originalClient) {
        this.originalClient = originalClient;
        var that = this;
        this.originalClient.get(`identity`).then(function (resp) {
            let user = resp.data.username;
            that.setState({ user: user, initialLoadDone: true });
        }).then(function () {
            that.loadChangeCommits();
        });
    }

    componentWillMount() {
        this.client = new JSClient({ onReady: this.clientLoaded });
    }

    getBeersResultHandler(beerResult) {
        this.setState({ beers: beerResult.beers, beerLoadDone: true });
    }

    headerCounter(items) {
        return items.length;
    }

    showAddModal() {
        this.setState({ isEditting: true });
    }

    markNotUsed() {
        if (window.confirm(`By marking not used, you acknowledge that this change is NOT used in application ${this.state.application}!
Continue?`)) {
            this.saveReleaseNote(true);
        }
    }

    hideAddModal() {
        this.setState({ isEditting: false });
    }

    saveReleaseNote(isEmptyReleaseNote) {
        const s = this;
        let changes = this.state.selectedChanges.map((it) => it.packageChangeId);
        let needManualVerify = this.state.needManualVerify;
        this.setState({
            isSaving: true
        });
        let newReleaseNote = isEmptyReleaseNote === true ? {application: this.state.application,
            description: "EMPTY_RELEASE_NOTE",
            changes: changes,
            impactedMarketplaces: [],
            codeReviews: [],
            relatedLinks: [],
            author: this.state.user,
            verificationSteps: ""
        } : { application: this.state.application,
            description: this.state.releaseNoteDecription,
            changes: changes,
            author: this.state.user,
            isUrgent: document.getElementById('isUrgent').checked,
            impactedMarketplaces: this.state.impactedMarketplaces,
            codeReviews: this.state.releaseNoteCRs,
            relatedLinks: document.getElementById('relatedLinks').value.split("\n").map((it) => it.trim()).filter((it) => it),
            needManualVerify,
            verificationSteps: needManualVerify ? document.getElementById('verificationSteps').value : ""
        };
        this.originalClient.post(`release-notes`, newReleaseNote).then(function () {
            s.hideAddModal();
            s.setState({
                saveReleaseNoteDone: true,
                isSaving: false
            });
            s.loadChangeCommits();
        });
    }

    loadChangeCommits() {
        this.setState({ changeCommitsLoadDone: false });
        var that = this;
        return this.originalClient.get(`change-commits?application=${this.state.application}&author=${this.state.user}&hasReleaseNote=false`)
            .then(function (resp) {
                let changeCommits = resp.data.changeCommits;
                changeCommits.forEach((it) => it.id = `${it.packageChangeId.packageName}@${it.packageChangeId.changeId}`);
                that.setState({ changeCommits: changeCommits, changeCommitsLoadDone: true });
            });
    }


    render() {
        if (!this.state.initialLoadDone) {
            return (<div className='offset-xxs-1 col-s-8 offset-l-2 col-xl-3'> <Spinner />  </div>)
        }
        return (
            <div>
                <Modal visible={this.state.isEditting} header="Create a release note" footer={(
                    <span className="awsui-util-f-r">
                        <Button variant="link" text="Cancel" disabled={this.state.isSaving} onClick={this.hideAddModal}></Button>
                        <Button variant="primary" text="Save" loading={this.state.isSaving} onClick={this.saveReleaseNote}></Button>
                    </span>
                )} >
                    {
                        this.state.isEditting &&
                        <FormSection header="Form section header">
                            <ColumnLayout>
                                <div data-awsui-column-layout-root="true">
                                    <div>
                                        <FormField label="Input the description" description="This is a description.">
                                            <Textarea controlId="description" value={this.state.releaseNoteDecription}
                                                onChange={(d) => this.setState({releaseNoteDecription: d.detail.value})} />
                                        </FormField>
                                        <FormField label=" Select impacted marketplaces/realms">
                                            <Multiselect options={this.state.marketplaceOptions} placeholder="Choose options" checkboxes={true}
                                                selectedLabel="Selected" onChange={this.handleImpactedMarketplacesChange}>
                                            </Multiselect>
                                        </FormField>
                                        <FormField label="Input the CR ID" description="only the id, one per line, e.g. CR-26239828">
                                            <Textarea controlId="codeReviews" value={this.state.releaseNoteCRs.join("\n")}
                                                onChange={this.handleCodeReviewsChange} />
                                        </FormField>
                                        <FormField label="Input other releated links" description="one per line">
                                            <Textarea controlId="relatedLinks" />
                                        </FormField>
                                        <FormField label="Is it urgent?" description="check only if you must release next week">
                                            <Checkbox controlId="isUrgent"> Urgent </Checkbox>
                                        </FormField>
                                        <FormField label="Require oncall to verify manually after the deployment?">
                                            <Checkbox controlId="needManualVerify" onChange={this.handleNeedManualVerifyChange}> Yes </Checkbox>
                                        </FormField>
                                        {
                                            this.state.needManualVerify &&
                                            <FormField label="Input detailed verification steps">
                                                <Textarea controlId="verificationSteps" />
                                            </FormField>
                                        }
                                    </div>
                                </div>
                            </ColumnLayout>
                        </FormSection>
                    }

                </Modal>

                <div>
                    <div>
                        <h2>Hello {this.state.user}!</h2>
                        <h2> Create release notes for <a href={`https://pipelines.amazon.com/pipelines/${this.state.application}`} target='_blank'>{this.state.application}</a></h2>

                        <Table
                            columnDefinitions={COLUMN_DEFINITIONS}
                            loading={!this.state.changeCommitsLoadDone}
                            header={(
                                <Header title="Changes" counter={this.headerCounter(this.state.changeCommits)}
                                />
                            )}
                            items={this.state.changeCommits}
                            empty={<div className="awsui-util-t-c">
                                <div className="awsui-util-pt-xs awsui-util-mb-xs">
                                    <b>{"You have no changes to release!"}</b>
                                </div>
                            </div>}
                        >

                            <TablePagination />
                            <TableSelection trackBy="id" onSelectionChange={this.handleSelectionChange}></TableSelection>
                        </Table>
                    </div>
                    <div className='awsui-row'>
                        <div className="col-xxs-12">
                            <Button variant="primary" loading={this.state.isSaving} onClick={this.showAddModal} disabled={!this.state.selectedChanges || this.state.selectedChanges.length == 0}>
                                Create Release Note
                                </Button>

                            <Button onClick={this.markNotUsed} loading={this.state.isSaving} disabled={!this.state.selectedChanges || this.state.selectedChanges.length == 0}>
                                Mark NOT Used
                                </Button>
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}


// WEBPACK FOOTER //
// ./src/components/change_table.jsx